module.exports = __webpack_public_path__ + "assets/details_idea.e0a227bb.svg";